import { VideoOutlineIcon } from './VideoOutlineIcon';

/**
 * author: Google
 * id 993D76B5-D3E5-4360-986D-3F13A04F29A7
 * name video-outline
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/video-outline.svg
 * tags
 * - Video / Movie 
 */
export const VideocamOutlineIcon = VideoOutlineIcon;
export default VideocamOutlineIcon